import request from '@/utils/request';

/* 收款单列表查询 */
export function getListShopMerchant(data) {
  return request({
    url: '/online/debitNote/listShopMerchantPage',
    method: 'post',
    data,
  });
}

/* 收款单-门店类型查询 */
export function queryDebitNoteList(params) {
  return request({
    url: '/online/debitNote/list',
    method: 'get',
    params,
  });
}

/* 收款单详情查询 */
export function queryDebitNoteDetail(params) {
  return request({
    url: '/online/debitNote/detail',
    method: 'get',
    params,
  });
}

/* 收款单记录列表 */
export function queryRecordList(params) {
  return request({
    url: '/online/debitNote/recordList',
    method: 'get',
    params,
  });
}

/* 线上收款单记录汇总 */
export function queryRecordSummary(params) {
  return request({
    url: '/online/debitNote/recordSummary',
    method: 'get',
    params,
  });
}

/* 线上收款单多个收款单记录汇总 */
export function queryListAllRecordSummary(params) {
  return request({
    url: '/online/debitNote/listAllRecordSummary',
    method: 'get',
    params,
  });
}

/* 查询商户收款单权限 */
export function queryOnlinePermission(params) {
  return request({
    url: '/online/debitNote/queryOnlinePermission',
    method: 'get',
    params,
  });
}

/* 获取收款单下拉选择列表 */
export function queryReceiptSelectList(params) {
  return request({
    url: '/receipt-order-trans/receiptNo-list',
    method: 'get',
    params,
  });
}

/* 收款单交易流水表格列表 */
export function getReceiptFlowList(data) {
  return request({
    url: '/receipt-order-trans/page-list',
    method: 'post',
    data,
  });
}

/* 收款单交易流水导出 */
export function exportReceiptFlowList(data) {
  return request({
    url: '/receipt-order-trans/export',
    method: 'post',
    data,
    responseType: 'blob',
  });
}

/* 收款单详情列表（新） */
export function getReceiptDetailList(data) {
  return request({
    url: '/receipt-order-trans/listByReceiptOrderNo',
    method: 'post',
    data,
  });
}

/* 收款单详情导出（新） */
export function exportReceiptDetailList(data) {
  return request({
    url: '/receipt-order-trans/exportByReceiptOrderNo',
    method: 'post',
    data,
  });
}

/* 创建收银点导入文件 */
export function importFile(data) {
  return request({
    url: '/online/debitNote/importFile',
    method: 'post',
    data,
  });
}

/* 创建收款单 */
export function createReceiveOrder(data) {
  return request({
    url: '/online/debitNote/createReceiveOrder',
    method: 'post',
    data,
  });
}

/* 重启/结束收款 */
export function closeOrOpenReceipt(data) {
  return request({
    url: '/online/debitNote/closeOrOpen',
    method: 'post',
    data,
  });
}
